import { Box, Container, Typography } from '@mui/material';
import bgImage from '../../assets/images/bgImage.png';
import CreateProfileForm from '../../components/CreateProfileForm';

const CreateProfile = () => {

    return (
    <Container maxWidth="false" sx={{padding:"48px"}}>
        <Box display="flex" flexDirection="column" sx={{height:{xs:"calc(100vh - 88px)", sm:"calc(100vh - 96px)"}}}>
            <Typography variant='h3' color='secondary'>Create a Profile</Typography>
            <CreateProfileForm/>
        </Box>
    </Container>
    )
}

export default CreateProfile
